import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//this will only suppress the console.log messages
if (process.env.NODE_ENV !== 'development') {
    console.log = () => {}
  }
ReactDOM.render(<App />, document.getElementById('root'));